import { Toast, Offcanvas } from "bootstrap";
import { xhrRequest } from "utils/xhr";

window.notice = ({ confirmString }) => {
  const notificationIcon = document.getElementById("notification_icon");
  const notificationLink = document.getElementById("notification_link");
  const unreadCountBadge = document.getElementById("notification_unread_count_badge");
  const unreadCountLabel = document.getElementById("notification_unread_count_label");
  const toastContainer = document.getElementById("notification_toast_container");
  const toastOffcanvas = document.getElementById("notification_toast_offcanvas");
  const bsToastOffcanvas = new Offcanvas(toastOffcanvas);
  const offcanvasToastAllCloseButton = document.getElementById("offcanvas_toast_clear_all_button");
  const toastOffcanvasCloseButton = document.getElementById("toast_offcanvas_close_button");
  const toastOffcanvasContainer = document.getElementById("notification_toast_offcanvas_container");
  const notificationNotFoundMessage = document.getElementById("notification_not_found_message");
  const includeReadCheckbox = document.getElementById("include_read_checkbox");
  let toastOffcanvasShown = false;

  const connection = new signalRNotifications.HubConnectionBuilder()
    .withUrl("/NotificationHub")
    .withAutomaticReconnect()
    .build();

  const notificationData = {
    isError: false,
    notificationCount: 0,
    unreadNotificationCount: 0,
    notificationList: [],
    notificationNodeList: [],
    notificationOffcanvasNodeList: [],
  };

  notificationIcon.addEventListener("click", (e) => {
    getNotifications({ includingNotified: null, includingRead: null }, createNotificationOffcanvasNode);
    bsToastOffcanvas.show();
    toastOffcanvasShown = true;
    e.stopPropagation();
  });

  notificationLink.addEventListener("click", (e) => {
    getNotifications({ includingNotified: null, includingRead: null }, createNotificationOffcanvasNode);
    bsToastOffcanvas.show();
    toastOffcanvasShown = true;
    e.stopPropagation();
  });

  toastOffcanvas.addEventListener("hidden.bs.offcanvas", () => {
    toastOffcanvasShown = false;
  });

  offcanvasToastAllCloseButton.addEventListener("click", (e) => {
    notificationData.notificationOffcanvasNodeList.forEach((node, index) => {
      node.hide();
      notificationData.notificationOffcanvasNodeList = notificationData.notificationOffcanvasNodeList.filter((n) => {
        return n != node;
      });
    });
    toggleNotificationOffcanvasPartsVisible();
    notificationData.notificationList.forEach((notification, index) => {
      if (!includeReadCheckbox.checked && notification.isRead) {
        return;
      }
      deleteNotification(notification.id);
      notificationData.notificationList = notificationData.notificationList.filter((data) => {
        return data.id != notification.id;
      });
    });
    e.stopPropagation();
  });

  toastOffcanvasCloseButton.addEventListener("click", (e) => {
    bsToastOffcanvas.hide();
    toastOffcanvasShown = false;
    getNotifications({ includingNotified: false, includingRead: false }, createNotificationNode);
    e.stopPropagation();
  });

  includeReadCheckbox.addEventListener("change", (e) => {
    createNotificationOffcanvasNode();
    e.stopPropagation();
  });

  function getNotifications({ includingNotified = null, includingRead = null }, callback) {
    xhrRequest(
      "GET",
      "Notifications",
      {
        isNotified: includingNotified,
        isRead: includingRead,
      },
      {
        success: data => {
          notificationData.notificationCount = data.count;
          notificationData.unreadNotificationCount = data.unreadCount;
          notificationData.notificationList = data.notifications;
          notificationData.isError = false;
          callback();
        },
        error: () => {
          notificationData.isError = true;
        },
        complete: () => {

        },
      }
    );
  }

  function updateUnreadCount() {
    xhrRequest(
      "GET",
      "Notifications",
      {
        isNotified: null,
        isRead: null,
      },
      {
        success: data => {
          removeChildrenNode(unreadCountBadge);
          notificationData.unreadNotificationCount = data.unreadCount;
          unreadCountBadge.innerText = notificationData.unreadNotificationCount ? notificationData.unreadNotificationCount : "";
          unreadCountLabel.innerText = notificationData.unreadNotificationCount ? `(${notificationData.unreadNotificationCount})` : "";
          notificationData.isError = false;
        },
        error: () => {
          notificationData.isError = true;
        },
        complete: () => {

        },
      }
    );
  }

  function createNotificationNode() {
    notificationData.notificationNodeList = [];

    removeChildrenNode(toastContainer);

    notificationData.notificationList.forEach((notification, index) => {
      let toast = document.createElement("div");
      toast.setAttribute("role", "alert");
      toast.setAttribute("aria-live", "assertive");
      toast.setAttribute("aria-atomic", "true");
      toast.classList.add("toast");
      toast.classList.add("hide");

      if (notification.isSimpleLayout === false) {
        let toastHeader = document.createElement("div");
        toastHeader.classList.add("toast-header");
        let toastHeaderText = document.createElement("strong");
        toastHeaderText.innerText = notification.title;
        toastHeader.appendChild(toastHeaderText);
        toast.appendChild(toastHeader);
      }

      let toastBody = document.createElement("div");
      toastBody.classList.add("toast-body");
      toastBody.innerText = notification.body;
      toast.appendChild(toastBody);

      let buttonWrapper = document.createElement("div");
      buttonWrapper.classList.add("toast-body");
      buttonWrapper.classList.add("text-end");

      let confirmButton = document.createElement("button");
      confirmButton.classList.add("btn");
      confirmButton.classList.add("btn-outline-primary");
      confirmButton.innerText = confirmString;

      buttonWrapper.appendChild(confirmButton);
      toast.appendChild(buttonWrapper);

      toastContainer.appendChild(toast);

      let convertedToast = new Toast(toast);

      confirmButton.addEventListener("click", (e) => {
        updateToRead(notification.id, convertedToast);
        e.stopPropagation();
      });
      toast.addEventListener("show.bs.toast", () => {
        updateToNotified(notification.id);
      });

      notificationData.notificationNodeList.push(convertedToast);
    });

    updateUnreadCount();

    notificationData.notificationNodeList.forEach(t => {
      t.show();
    });
  }

  function createNotificationOffcanvasNode() {
    notificationData.notificationOffcanvasNodeList = [];

    removeChildrenNode(toastOffcanvasContainer);

    notificationData.notificationList.forEach((notification) => {
      if (!includeReadCheckbox.checked && notification.isRead) {
        return;
      }

      let toast = document.createElement("div");
      toast.setAttribute("role", "alert");
      toast.setAttribute("aria-live", "assertive");
      toast.setAttribute("aria-atomic", "true");
      toast.classList.add("toast");
      toast.classList.add("show");
      toast.classList.add("mx-auto");
      toast.classList.add("my-4");
      if (notification.isRead) toast.classList.add("opacity-75");
      toast.dataset.bsAutohide = false;
      toast.dataset.id = notification.id;

      let closeButton = document.createElement("button");
      closeButton.setAttribute("type", "button");
      closeButton.classList.add("btn-close");

      let toastBody = document.createElement("div");
      toastBody.innerText = notification.body;

      if (notification.isSimpleLayout) {
        toastBody.classList.add("m-2");
        toastBody.classList.add("me-auto");
        closeButton.classList.add("m-2");
        let bodyWrapper = document.createElement("div");
        bodyWrapper.classList.add("d-flex");
        bodyWrapper.appendChild(toastBody);
        bodyWrapper.appendChild(closeButton);
        toast.appendChild(bodyWrapper);
      } else {
        let toastHeader = document.createElement("div");
        toastHeader.classList.add("toast-header");
        let toastHeaderText = document.createElement("strong");
        toastHeaderText.classList.add("me-auto");
        toastHeaderText.innerText = notification.title;
        toastHeader.appendChild(toastHeaderText);
        toastHeader.appendChild(closeButton);
        toast.appendChild(toastHeader);
        toastBody.classList.add("toast-body");
        toast.appendChild(toastBody);
      }

      let confirmButton = document.createElement("button");
      let buttonWrapper = document.createElement("div");
      if (notification.isRead === false) {
        buttonWrapper.classList.add("toast-body");
        buttonWrapper.classList.add("text-end");

        confirmButton.classList.add("btn");
        confirmButton.classList.add("btn-outline-primary");
        confirmButton.innerText = confirmString;

        buttonWrapper.appendChild(confirmButton);
        toast.appendChild(buttonWrapper);
      }

      toastOffcanvasContainer.appendChild(toast);
      let convertedToast = new Toast(toast);

      if (notification.isRead === false) {
        confirmButton.addEventListener("click", (e) => {
          if (includeReadCheckbox.checked) {
            toast.classList.add("opacity-75");
            removeChildrenNode(buttonWrapper);
            updateToRead(notification.id);
          } else {
            updateToRead(notification.id, convertedToast);
          }
          e.stopPropagation();
        });
      }

      closeButton.addEventListener("click", (e) => {
        deleteNotification(notification.id, convertedToast);
        e.stopPropagation();
      });

      notificationData.notificationOffcanvasNodeList.push(convertedToast);
    });

    toggleNotificationOffcanvasPartsVisible();
  }

  function toggleNotificationOffcanvasPartsVisible() {
    if (notificationData.notificationOffcanvasNodeList.length) {
      offcanvasToastAllCloseButton.classList.remove("d-none");
      notificationNotFoundMessage.classList.add("d-none");
    } else {
      offcanvasToastAllCloseButton.classList.add("d-none");
      notificationNotFoundMessage.classList.remove("d-none");
    }
  }

  function removeChildrenNode(target) {
    while (target.firstChild) {
      target.removeChild(target.firstChild);
    }
  }

  function updateToRead(id, targetToast = null) {
    let targetData = notificationData.notificationList.find(n => n.id === id);
    targetData.isRead = true;
    if (targetToast) targetToast.hide();
    xhrRequest(
      "PUT",
      `Notifications/${id}`,
      targetData,
      {
        success: data => {
          targetData = data;
          notificationData.isError = false;
        },
        error: () => {
          notificationData.isError = true;
        },
        complete: () => {
          notificationData.notificationOffcanvasNodeList = notificationData.notificationOffcanvasNodeList.filter((n) => {
            return n != targetToast;
          });
          toggleNotificationOffcanvasPartsVisible();
          updateUnreadCount();
        },
      }
    );
  }

  function updateToNotified(id, targetToast = null) {
    let targetData = notificationData.notificationList.find(n => n.id === id);
    targetData.isNotified = true;
    if (targetToast) targetToast.hide();
    xhrRequest(
      "PUT",
      `Notifications/${id}`,
      targetData,
      {
        success: data => {
          targetData = data;
          notificationData.isError = false;
        },
        error: () => {
          notificationData.isError = true;
        },
        complete: () => {
          notificationData.notificationOffcanvasNodeList = notificationData.notificationOffcanvasNodeList.filter((n) => {
            return n != targetToast;
          });
          toggleNotificationOffcanvasPartsVisible();
          updateUnreadCount();
        },
      }
    );
  }

  function deleteNotification(id, targetToast = null) {
    let targetData = notificationData.notificationList.find(n => n.id === id);
    if (targetToast) targetToast.hide();
    xhrRequest(
      "DELETE",
      `Notifications/${id}`,
      targetData,
      {
        success: data => {
          targetData = data;
          notificationData.isError = false;
        },
        error: () => {
          notificationData.isError = true;
        },
        complete: () => {
          notificationData.notificationOffcanvasNodeList = notificationData.notificationOffcanvasNodeList.filter((n) => {
            return n != targetToast;
          });
          toggleNotificationOffcanvasPartsVisible();
          updateUnreadCount();
        },
      }
    );
  }

  connection.on("ReceiveNotification", () => {
    if (toastOffcanvasShown) return;
    getNotifications({ includingNotified: false, includingRead: false }, createNotificationNode);
  });

  (() => {
    try {
      connection.start();
      notificationData.isError = false;
    } catch (err) {
      notificationData.isError = true;
    }

    getNotifications({ includingNotified: false, includingRead: false }, createNotificationNode);
  })();
}
